import React from 'react';
import { Button } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { GetProjectDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { DownloadAttachment } from '../Attachments/DownloadAttachment';

import { AttachmentId } from './useSalesInvoiceData';

interface ProjectLinkProps {
  project: GetProjectDto;
  goToProject: (id: string) => void;
}

const ProjectLink: React.FC<ProjectLinkProps> = ({ project, goToProject }) => (
  <Button
    variant="link"
    className="p-0 align-baseline text-nowrap"
    onClick={() => goToProject(project.id)}
  >
    {project.number}
  </Button>
);

interface InstructionButtonProps {
  attachmentId?: string;
}

const InstructionButton: React.FC<InstructionButtonProps> = ({
  attachmentId,
}) => {
  const { t, tk } = useTranslation('fvsLng');

  if (!attachmentId) {
    return null;
  }

  return (
    <DownloadAttachment
      id={attachmentId}
      iconSize={0}
      tooltipText={t(tk.finance.invoiceInstruction)}
      modalTitleText={t(tk.finance.invoiceInstruction)}
      label={t(tk.finance.invoiceInstructionShort)}
    />
  );
};

interface SalesInvoiceHeaderProjectsProps {
  projects: GetProjectDto[];
  attachmentIds?: AttachmentId[];
  goToProject: (id: string) => void;
}

export const SalesInvoiceHeaderProjects: React.FC<
  SalesInvoiceHeaderProjectsProps
> = ({ projects, attachmentIds, goToProject }) => {
  const { t, tk } = useTranslation('fvsLng');

  const findAttachmentId = (projectId: string) =>
    attachmentIds?.find(a => a.projectId === projectId)?.id;

  if (!projects.length) {
    return null;
  }

  return (
    <li>
      <div className="d-inline-flex flex-wrap align-items-center column-gap-2">
        <span>
          {projects.length === 1
            ? `${t(tk.prLang.project)}:`
            : `${t(tk.prLang.projects)} (${projects.length}):`}
        </span>
        {projects.map(project => (
          <span
            key={project.id}
            className="sales-invoice-project d-inline-flex align-items-center gap-1"
          >
            <ProjectLink project={project} goToProject={goToProject} />
            <span className="sales-invoice-project-name" title={project.name}>
              {project.name}
            </span>
            <InstructionButton attachmentId={findAttachmentId(project.id)} />
          </span>
        ))}
      </div>
    </li>
  );
};
